<template>
  <div class="ontag">
    <div class="ontag__content">
      <div>
        <span
          v-if="fundingTodo.externalId"
          class="h1">
          Update project funding and budget
        </span>
        <span
          v-else
          class="h1">
          Budget/Funding
        </span>
        <span
          v-if="isLoading"
          class="element--is-loading">
        </span>
      </div>
      <template v-if="fundingTodo && !isLoading">
        <template v-if="(id || handleTask) && fundingTodo">
          <a @click="showNone"> &lt; Back to list </a>
          <section>
            <card :info="cardInfo" />
            <table class="budgetTable">
              <thead>
                <th>Year</th>
                <th>Month</th>
                <th>Type</th>
                <th>Value</th>
                <th>Currency</th>
              </thead>
              <tr
                v-for="(funding, i) in fundingTodo.budgets"
                v-bind:key="i">
                <td>{{ funding.year }}</td>
                <td>{{ funding.month }}</td>
                <td>{{ funding.type }}</td>
                <td>{{ funding.value }}</td>
                <td>{{ funding.currency }}</td>
              </tr>
            </table>

            <p>TE order comment</p>
            <textarea
              v-if="fundingTodo.teComment"
              disabled
              v-model="fundingTodo.teComment"></textarea>
            <br />
            <br />
            <label>Comment (Mandatory input if Delete or Pause)</label>
            <br />
            <textarea v-model="fundingTodo.comment"></textarea>
            <br />
            <p v-if="fundingTodo.doneBy">
              Forecast done by: {{ fundingTodo.doneBy }}
            </p>
            <p v-if="fundingTodo.pausedBy">
              Forecast paused by: {{ fundingTodo.pausedBy }}
            </p>
            <p v-if="fundingTodo.deletedBy">
              Forecast deleted by: {{ fundingTodo.deletedBy }}
            </p>
            <p v-if="fundingTodo.cancelled">Task cancelled</p>
            <template v-if="fundingTodo.externalId">
              <div class="input-group--inline">
                <a @click="showNone"> &lt; Previous </a>
                <base-button
                  class="button--background-gray-dark"
                  @click="showNone"
                  text="Cancel">
                </base-button>
                <base-button
                  class="button--background-red"
                  :disabled="setDisabledButton('pause') || !fundingTodo.comment"
                  @click="setTaskStatus('Paused')"
                  :text="
                    'Pause' +
                    (index < fundingTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-red"
                  :disabled="
                    setDisabledButton('delete') || !fundingTodo.comment
                  "
                  @click="setTaskStatus('Deleted')"
                  :text="
                    'Delete' +
                    (index < fundingTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-blue"
                  :disabled="setDisabledButton('done')"
                  @click="setTaskStatus('Done')"
                  :text="
                    'Done' +
                    (index < fundingTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
              </div>
            </template>
          </section>
        </template>
        <template v-else-if="fundingTodos">
          <section class="todos_top-container">
            <input
              type="text"
              placeholder="Search"
              v-model="searchQuery" />
            <base-button
              :disabled="isLoading"
              text="Handle tasks"
              @click="handleTasks(0)">
            </base-button>
            <card :info="totalCardInfo" />
          </section>
          <table>
            <thead>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Status"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'status')"
                  :options="filterValues('status')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Projectnumber"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'terpId')"
                  :options="filterValues('terpId')">
                </multi-select>
              </th>
              <th>Customer</th>
              <th>Club name</th>
              <th>Order no.</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Delivery week"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'deliveryWeek')"
                  :options="filterValues('deliveryWeek')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Delivery year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'deliveryYear')"
                  :options="filterValues('deliveryYear')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Revenue month"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'revenueMonth')"
                  :options="filterValues('revenueMonth')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Revenue year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'revenueYear')"
                  :options="filterValues('revenueYear')">
                </multi-select>
              </th>
              <th>Revenue</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Cost month"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'costMonth')"
                  :options="filterValues('costMonth')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Cost year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'costYear')"
                  :options="filterValues('costYear')">
                </multi-select>
              </th>
              <th>Cost</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Last update"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'lastChanged')"
                  :options="filterValues('lastChanged')">
                </multi-select>
              </th>
              <th></th>
            </thead>
            <tr
              v-for="(fundingTodo, i) in fundingTodos"
              v-bind:key="i">
              <td>{{ fundingTodo.status }}</td>
              <td>{{ fundingTodo.terpId }}</td>
              <td>{{ fundingTodo.customer }}</td>
              <td>{{ fundingTodo.clubName }}</td>
              <td>{{ fundingTodo.orderNumber }}</td>
              <td>{{ fundingTodo.deliveryWeek }}</td>
              <td>{{ fundingTodo.deliveryYear }}</td>
              <td>{{ fundingTodo.revenueMonth }}</td>
              <td>{{ fundingTodo.revenueYear }}</td>
              <td>{{ fundingTodo.revenue }}</td>
              <td>{{ fundingTodo.costMonth }}</td>
              <td>{{ fundingTodo.costYear }}</td>
              <td>{{ fundingTodo.cost }}</td>
              <td>
                {{
                  fundingTodo.lastChanged == '' ||
                  fundingTodo.lastChangedBy == ''
                    ? ''
                    : fundingTodo.lastChanged +
                      ' by ' +
                      fundingTodo.lastChangedBy
                }}
              </td>
              <td @click="handleFundingTodo(fundingTodo.externalId)">
                <use-svg
                  svg="arrow-right"
                  class="svg--90-negative" />
              </td>
            </tr>
          </table>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import MultiSelect from '@/components/form-elements/multi-select';
import UseSvg from '@/components/use-svg';
import Card from '@/components/info/card.vue';

export default {
  name: 'RevenueCost',
  components: {
    BaseButton,
    MultiSelect,
    UseSvg,
    Card,
  },
  props: {
    id: {
      type: String,
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.$store.dispatch('todo/getFundingTodo', { id: newId });
        } else {
          this.showNone();
        }
      },
    },
  },
  data() {
    return {
      filter: {
        status: ['Paused', 'To do'],
        terpId: [],
        deliveryWeek: [],
        deliveryYear: [],
        revenueMonth: [],
        revenueYear: [],
        costMonth: [],
        costYear: [],
        lastChanged: [],
      },
      sortBy: 'changedDate',
      handleTask: false,
      index: 0,
      isLoading: true,
      searchQuery: '',
    };
  },
  computed: {
    _fundingTodos() {
      return this.$store.getters['todo/fundingTodos'];
    },
    totalCardInfo() {
      return [
        {
          id: 1,
          label: 'No of events in list:',
          value: this.fundingTodos.length,
        },
        {
          id: 2,
          label: 'Sum of revenue in the list:',
          value: `${this.sumOfRevenue()} kr`,
        },
        {
          id: 3,
          label: 'Sum of cost in the list:',
          value: `${this.sumOfCost()} kr`,
        },
      ];
    },
    cardInfo() {
      return [
        { id: 1, label: 'Status:', value: this.fundingTodo.status },
        { id: 2, label: 'Order no.', value: this.fundingTodo.orderNumber },
        { id: 3, label: 'Customer in TERP:', value: this.fundingTodo.customer },
        { id: 4, label: 'Club name:', value: this.fundingTodo.clubName },
        {
          id: 5,
          label: 'Project no. in TERP:',
          value: this.fundingTodo.terpId,
        },
      ];
    },
    fundingTodos() {
      let et = this._fundingTodos;

      if (this.searchQuery) {
        const searchLower = this.searchQuery.toLowerCase();
        et = et.filter(todo =>
          Object.values(todo).some(value =>
            typeof value === 'string'
              ? value.toLowerCase().includes(searchLower)
              : value.toString().toLowerCase().includes(searchLower)
          )
        );
      }

      for (let f of Object.keys(this.filter)) {
        if (this.filter[f].length > 0) {
          et = et.filter(a => {
            return a.hasOwnProperty(f) && this.filter[f].includes(a[f]);
          });
        }
      }

      return et.sort((a, b) => {
        if (!(this.sortBy in a) || !(this.sortBy in b)) return -1;
        return a[this.sortBy] > b[this.sortBy] ? 1 : -1;
      });
    },
    fundingTodo() {
      return this.$store.getters['todo/fundingTodo'];
    },
  },
  async mounted() {
    this.isLoading = true;
    if (!this.id && !this._fundingTodos.length) {
      await this.$store.dispatch('todo/getFundingTodos');
    }
    this.isLoading = false;
  },
  methods: {
    handleTasks(index) {
      if (index < this.fundingTodos.length - 1) {
        this.showFundingTodo(this.fundingTodos[index].externalId, index);
        this.handleTask = true;
      } else {
        this.showFundingTodo(this.fundingTodos[index].externalId, index);
        this.handleTask = false;
      }
    },
    toggleModal() {
      this.isLoading = !this.isLoading;
    },
    async setTaskStatus(status) {
      await this.$store
        .dispatch('todo/patchFundingTodo', {
          id: this.fundingTodo.externalId,
          status: status,
          comment: this.fundingTodo.comment,
        })
        .then(() => {
          if (this.handleTask && this.index < this.fundingTodos.length - 1) {
            this.index += 1;
            this.handleTasks(this.index);
          } else {
            this.showNone();
          }
        });
    },
    sumOfRevenue() {
      if (this.fundingTodos) {
        let myArray = this.fundingTodos.map(revenues => revenues.revenue);
        let sumOfArray = myArray.reduce((pv, cv) => pv + cv, 0);
        return sumOfArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    sumOfCost() {
      if (this.fundingTodos) {
        let myArray = this.fundingTodos.map(costs => costs.cost);
        let sumOfArray = myArray.reduce((pv, cv) => pv + cv, 0);
        return sumOfArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    showFundingTodo(id, index) {
      this.$store.dispatch('todo/getFundingTodo', { id: id });
      this.index = index;
    },
    handleFundingTodo(id) {
      this.$router.push({ name: 'todo-revenue-cost', params: { id: id } });
    },
    setDisabledButton(buttonType) {
      let status = this.fundingTodo.status.toLowerCase();
      let disabledStatuses = {
        delete: ['deleted', 'cancelled'],
        pause: ['cancelled', 'paused'],
        done: ['done', 'cancelled'],
        todo: ['to do', 'cancelled'],
      };

      return disabledStatuses[buttonType].includes(status);
    },
    showNone() {
      this.fundingTodo.externalId = '';
      this.handleTask = false;
      this.index = 0;
      if (this.id) {
        this.$router.push({ name: 'todo-revenue-cost' });
      }
    },
    filterValues(prop) {
      return [...new Set(this._fundingTodos.map(a => a[prop]))].map(a => {
        return {
          displayName: a === '' ? 'None' : a,
          value: a,
          checked: this.filter[prop].includes(a),
        };
      });
    },
    filterResults(e, prop) {
      this.filter[prop] = e.options
        .filter(option => option.checked)
        .map(o => o.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.todos_top-container {
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 12px;
  margin-bottom: 12px;

  input {
    width: 200px;
  }
}

.button {
  width: 150px;
  margin: 5px;
}

table {
  border-collapse: collapse;
  table-layout: auto;
  width: auto;
  th {
    padding: 0 0.625rem;
    text-align: left;
    background-color: color(blue-light);
  }
  tr {
    &.pointer {
      cursor: auto;
    }
    &:nth-child(even) {
      background-color: color(gray-lighter);
    }
    &.checked {
      background-color: color(blue-light);
    }
  }
  td {
    padding: 0.625rem;
    &:last-child {
      padding-right: 0;
      cursor: pointer;
    }
  }
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
  margin-top: 20px;
  margin-bottom: 20px;
}
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: 20px;
}
.ontag {
  flex-grow: 1;
  width: 100%;
  @include media('small') {
    width: calc((100% / 2) - (1rem * 1));
  }
  @include media('large') {
    width: calc((100% / 3) - (1rem * 2));
  }
}
.ontag__content {
  background-color: color(white);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  &.dashboard {
    background-color: transparent;
    border-radius: 0;
  }
}
.input-group--inline {
  button {
    margin: 0.5rem;
  }
}
</style>
